import React from 'react';
import {Trans} from 'react-i18next';
import {ConnectionRequestStatus, IConnectionRequest} from '../../../incase-domain/connection';

interface IConnectionNotificationTextProps {
    connectionRequest: IConnectionRequest;
}

function ConnectionNotificationText({connectionRequest}: IConnectionNotificationTextProps): JSX.Element | null {
    return ((): JSX.Element | null => {
        switch (connectionRequest.status) {
            case ConnectionRequestStatus.PENDING:
                return (
                    <Trans
                        i18nKey="notifications.connectionRequest.request"
                        components={{bold: <strong />}}
                        values={{email: connectionRequest.senderEmail}}
                    />
                );
            case ConnectionRequestStatus.ACCEPTED:
                return (
                    <Trans
                        i18nKey="notifications.connectionRequest.requestAccepted"
                        components={{bold: <strong />}}
                        values={{email: connectionRequest.receiverEmail}}
                    />
                );
            case ConnectionRequestStatus.DECLINED:
                return (
                    <Trans
                        i18nKey="notifications.connectionRequest.requestDeclined"
                        components={{bold: <strong />}}
                        values={{email: connectionRequest.receiverEmail}}
                    />
                );
            default:
                return null;
        }
    })();
}

export default ConnectionNotificationText;
